/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {TestBedRender3 as ɵangular_packages_core_testing_testing_b,_getTestBedRender3 as ɵangular_packages_core_testing_testing_c} from './src/r3_test_bed';
export {TestBedViewEngine as ɵangular_packages_core_testing_testing_a} from './src/test_bed';